/**
 * Questo file contiene i messaggi d'errore dei vari form
 * usati da jQuery-validate
 * 
 * @type Object
 */
oLang.validazioni = {
    consulenzaMutuo: {
        nome: {
            required: "Il campo nome è obbligatorio",
            maxlength: "Lunghezza massima 255 caratteri"
        },
        cognome: {
            required: "Il campo cognome è obbligatorio",
            maxlength: "Lunghezza massima 255 caratteri"
        },
        email: {
            required: "L'indirizzo email è obbligatorio",
            email: "Formato email non corretto",
            maxlength: "Lunghezza massima 255 caratteri"
        },
        messaggio: {
            required: "Il campo messaggio è obbligatorio",
            maxlength: "Lunghezza massima 255 caratteri"
        },
        privacy: {
            required: "Devi accettare la privacy",
        }
    }
}